/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


export default class RefreshTokenError extends Error {

  public readonly safe = true;
  constructor(public readonly code = RefreshTokenError.NotAvailable) {
    super(RefreshTokenError.getMessage(code));
    Object.setPrototypeOf(this, RefreshTokenError.prototype);
  }

  public static NotAvailable = 'not_available';
  public static FailedToRefresh = 'failed_refresh';

  public static getMessage(code: string)  {
    return this.codeMessage[code] ?? 'Generic Refresh Token error';
  }

  private static codeMessage = {
    [RefreshTokenError.NotAvailable]: 'Refresh Token is not available'
  }
}
